export const USER = `USER`;
export const LOGIN_USER_REQUEST = `${USER}/loginRequest`;
export const LOGOUT_USER_REQUEST = `${USER}/logoutRequest`;
export const REGISTER_USER_REQUEST = `${USER}/registerRequest`;
export const VERIFY_USER_REQUEST = `${USER}/verifyRequest`;
export const FORGOT_PASSWORD_REQUEST = `${USER}/forgotPasswordRequest`;
export const RESET_PASSWORD_REQUEST = `${USER}/resetPasswordRequest`;
export const GET_USER_REQUEST = `${USER}/getUserRequest`;
export const UPDATE_USER_REQUEST = `${USER}/updateUserRequest`;
export const GET_NOTIFICATION_REQUEST = `${USER}/getNotificationRequest`;
export const UPDATE_NOTIFICATION_REQUEST = `${USER}/updateNotificationRequest`;
// export const SUBSCRIBE_NOTIFICATION_REQUEST = `${USER}/subscribeNotificationRequest`;
